import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Headphones } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] flex flex-col items-center justify-center overflow-hidden py-12 px-4" data-id="element-123">
      <div className="relative z-20 max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-124">
        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6" data-id="element-125">
          <h1 className="text-4xl md:text-6xl font-matrix tracking-wider uppercase text-matrix-orange mb-2" data-id="element-126">
            No necesitas otro consejo.
          </h1>
          <h1 className="text-4xl md:text-6xl font-matrix tracking-wider uppercase text-matrix-primary text-glow" data-id="element-127">
            Necesitas un reset.
          </h1>
        </motion.div>

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="mb-10 max-w-2xl w-full" data-id="element-128">
          <div className="relative pl-4 border-l-2 border-matrix-red/40 space-y-5" data-id="element-129">
            <motion.p initial={{
            opacity: 0,
            x: -20,
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            x: 0,
            filter: 'blur(0px)'
          }} transition={{
            delay: 0.5,
            duration: 0.7
          }} className="text-lg md:text-xl text-matrix-text/70" data-id="element-130">
              Es el cansancio de vivir{' '}
              <span className="text-matrix-red font-bold" style={{
              textShadow: '0 0 12px rgba(255, 51, 51, 0.6)'
            }} data-id="element-131">
                reaccionando
              </span>
              .
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            x: -20,
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            x: 0,
            filter: 'blur(0px)'
          }} transition={{
            delay: 0.9,
            duration: 0.7
          }} className="text-lg md:text-xl text-matrix-text/80" data-id="element-132">
              De abrir el teléfono{' '}
              <span className="text-matrix-orange italic" data-id="element-133">"un segundo"</span> y
              volver{' '}
              <span className="text-matrix-text font-semibold" data-id="element-134">
                diez minutos después
              </span>{' '}
              con la mente más sucia.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            x: -20,
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            x: 0,
            filter: 'blur(0px)'
          }} transition={{
            delay: 1.3,
            duration: 0.7
          }} className="text-xl md:text-2xl text-matrix-text/90 font-medium" data-id="element-135">
              De prometerte que mañana sí… y sentir, en secreto, que{' '}
              <motion.span animate={{
              textShadow: ['0 0 8px rgba(255, 51, 51, 0.3)', '0 0 20px rgba(255, 51, 51, 0.8)', '0 0 8px rgba(255, 51, 51, 0.3)']
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-matrix-red font-bold" data-id="element-136">
                ya no confías en ti
              </motion.span>
              .
            </motion.p>
          </div>
        </motion.div>

        {/* Audiobook Preview */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 0.7
      }} className="w-full max-w-md mx-auto mb-4" data-id="element-137">
          <div className="bg-matrix-bg border border-matrix-primary/40 rounded-lg overflow-hidden shadow-[0_0_20px_rgba(0,255,65,0.15)]" data-id="element-138">
            {/* Terminal-style header bar */}
            <div className="flex items-center gap-3 px-4 py-3 border-b border-matrix-primary/20 bg-matrix-surface/60" data-id="element-139">
              <div className="flex gap-1.5" data-id="element-140">
                <div className="w-2 h-2 rounded-full bg-matrix-red/70" data-id="element-141" />
                <div className="w-2 h-2 rounded-full bg-matrix-orange/70" data-id="element-142" />
                <div className="w-2 h-2 rounded-full bg-matrix-primary/70" data-id="element-143" />
              </div>
              <div className="flex items-center gap-2 flex-1" data-id="element-144">
                <Headphones className="w-4 h-4 text-matrix-primary" data-id="element-145" />
                <p className="text-matrix-primary text-xs font-matrix tracking-widest uppercase" data-id="element-146">
                  {'>'} Preview — Track 1
                </p>
              </div>
            </div>

            {/* Decorative waveform */}
            <div className="flex items-end justify-center gap-[2px] px-4 pt-3 pb-1 h-8" data-id="element-147">
              {Array.from({
              length: 40
            }).map((_, i) => {
              const h = Math.sin(i * 0.35) * 0.5 + 0.5;
              return <div key={i} className="w-[2px] rounded-full bg-matrix-primary/30 animate-pulse" style={{
                height: `${Math.max(h * 100, 20)}%`,
                animationDelay: `${i * 80}ms`,
                animationDuration: '2s'
              }} data-id="element-148" />;
            })}
            </div>

            {/* Subtitle */}
            <p className="text-matrix-muted text-[10px] tracking-wider uppercase text-center px-4 pb-2 font-matrix" data-id="element-149">
              [ Escucha un fragmento del audiolibro ]
            </p>

            {/* Iframe player */}
            <div className="w-full bg-black/80 border-t border-matrix-primary/10 relative" style={{
            height: '80px'
          }} data-id="element-150">
              <iframe src="https://drive.google.com/file/d/1K2EJHFjXpSBzMz3LvpNggpnf0qX7fVo4/preview" width="100%" height="80" allow="autoplay" style={{
              border: 'none'
            }} title="Mente Maestra - Preview Track 1" data-id="element-151" />
              {/* Overlay to hide Google Drive pop-out button (top-right corner) */}
              <div className="absolute top-0 right-0 w-14 h-14 bg-matrix-bg pointer-events-auto z-10" data-id="element-152" />
            </div>
          </div>
        </motion.div>

        {/* CTA - scrolls to pricing */}
        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.8
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => {
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="group relative px-8 py-4 bg-matrix-primary/10 border border-matrix-primary text-matrix-primary font-bold text-lg rounded-sm hover:bg-matrix-primary hover:text-matrix-bg transition-all duration-300 shadow-[0_0_15px_rgba(0,255,65,0.2)] hover:shadow-[0_0_25px_rgba(0,255,65,0.6)] flex items-center gap-2 mb-6" data-id="element-153">
          Haz tu reset
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-154" />
        </motion.button>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="relative mb-6 w-full max-w-md mx-auto" data-id="element-155">
          <div className="absolute inset-0 bg-matrix-primary/20 blur-3xl rounded-full transform scale-75" data-id="element-156" />
          <img src="https://cdn.magicpatterns.com/uploads/4WJqikAib1kVUdEAgxnVkd/heylloyd-image-1770528887964.png" alt="Mente Maestra Product" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-157" />
        </motion.div>

        {/* Product Description & Tagline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} className="text-center mb-6" data-id="element-158">
          <p className="text-matrix-text text-lg mb-2" data-id="element-159">
            Mente Maestra es un audiolibro-ritual de 1 hora + un workbook
            simple.
          </p>
          <p className="text-matrix-orange font-bold text-xl tracking-wide" data-id="element-160">
            Treinta días. Tres portales. Un regreso.
          </p>
        </motion.div>
      </div>
    </section>;
}